import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as react from "react";
import { LineContainerComponent } from "../../sharedComponents/lineContainerComponent.js";
import { GeneralPropertyTabComponent, GenericPropertyComponent } from "./genericNodePropertyComponent.js";
import { OptionsLine } from "shared-ui-components/lines/optionsLineComponent.js";
import { ConnectionPointType, GetSmartFilterEditableProperties } from "smart-filters";
import { Color3PropertyTabComponent } from "../../components/propertyTab/properties/color3PropertyTabComponent.js";
import { Color4PropertyTabComponent } from "../../components/propertyTab/properties/color4PropertyTabComponent.js";
import { ImageSourcePropertyTabComponent } from "../../components/propertyTab/properties/imageSourcePropertyTabComponent.js";
import { FloatPropertyTabComponent } from "../../components/propertyTab/properties/floatPropertyTabComponent.js";
import { Vector2PropertyTabComponent } from "../../components/propertyTab/properties/vector2PropertyTabComponent.js";
import { LazyTextInputLineComponent } from "../../sharedComponents/lazyTextInputLineComponent.js";
const BooleanOptions = [
    {
        label: "True",
        value: 1,
    },
    {
        label: "False",
        value: 0,
    },
];
export class InputPropertyComponent extends react.Component {
    constructor(props) {
        super(props);
    }
    render() {
        // If this InputBlock has editable properties, it means it uses @editableProperty to define its properties
        // So we will assume that the developer of that InputBlock intends to use the GenericPropertyComponent
        if (GetSmartFilterEditableProperties(this.props.nodeData.data).length) {
            return _jsx(GenericPropertyComponent, { stateManager: this.props.stateManager, nodeData: this.props.nodeData });
        }
        return (_jsxs("div", { children: [_jsx(GeneralPropertyTabComponent, { stateManager: this.props.stateManager, nodeData: this.props.nodeData }), _jsx(LineContainerComponent, { title: "PROPERTIES", children: _jsx(InputPropertyTabComponent, { stateManager: this.props.stateManager, inputBlock: this.props.nodeData.data }) }), _jsx(LineContainerComponent, { title: "APP METADATA", children: _jsx("div", { id: "appMetadata", children: _jsx(LazyTextInputLineComponent, { lockObject: this.props.stateManager.lockObject, label: "appMetadata", multilines: true, target: this.props.nodeData.data, propertyName: "appMetadata", formatValue: (value) => {
                                return value ? JSON.stringify(value) : "";
                            }, extractValue: (value) => {
                                return value ? JSON.parse(value) : undefined;
                            }, onExtractValueFailed: () => {
                                this.props.stateManager.onErrorMessageDialogRequiredObservable.notifyObservers("Invalid JSON");
                            } }, this.props.nodeData.uniqueId) }) })] }));
    }
}
/**
 * Given an input block, returns the appropriate property component for the block's type
 */
export class InputPropertyTabComponent extends react.Component {
    // private _onValueChangedObserver: Nullable<Observer<AnyInputBlock>> = null;
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        // const inputBlock = this.props.nodeData.data as AnyInputBlock;
        // this._onValueChangedObserver = inputBlock.onValueChangedObservable.add(() => {
        //     this.forceUpdate();
        //     this.props.stateManager.onUpdateRequiredObservable.notifyObservers(inputBlock);
        // });
    }
    componentWillUnmount() {
        // const inputBlock = this.props.nodeData.data as AnyInputBlock;
        // if (this._onValueChangedObserver) {
        //     inputBlock.onValueChangedObservable.remove(this._onValueChangedObserver);
        //     this._onValueChangedObserver = null;
        // }
    }
    setDefaultValue() {
        // const inputBlock = this.props.nodeData.data as InputBlock;
        // inputBlock.setDefaultValue();
    }
    render() {
        const inputBlock = this.props.inputBlock;
        // Use the default property component
        switch (inputBlock.type) {
            case ConnectionPointType.Boolean: {
                const dummyTarget = {
                    value: true,
                };
                return (_jsx(OptionsLine, { label: "Value", target: dummyTarget, propertyName: "value", options: BooleanOptions, noDirectUpdate: true, extractValue: () => {
                        return inputBlock.runtimeValue.value ? 1 : 0;
                    }, onSelect: (newSelectionValue) => {
                        inputBlock.runtimeValue.value = newSelectionValue === 1;
                        this.props.stateManager.onUpdateRequiredObservable.notifyObservers(inputBlock);
                    } }, inputBlock.uniqueId));
            }
            case ConnectionPointType.Float: {
                return _jsx(FloatPropertyTabComponent, { inputBlock: inputBlock, stateManager: this.props.stateManager }, inputBlock.uniqueId);
            }
            case ConnectionPointType.Texture:
                {
                    return _jsx(ImageSourcePropertyTabComponent, { inputBlock: inputBlock, stateManager: this.props.stateManager }, inputBlock.uniqueId);
                }
                break;
            // case NodeMaterialBlockConnectionPointTypes.Vector2:
            //     return <Vector2PropertyTabComponent lockObject={globalState.lockObject} globalState={globalState} inputBlock={inputBlock} />;
            case ConnectionPointType.Color3:
                return (_jsx(_Fragment, { children: _jsx(Color3PropertyTabComponent, { stateManager: this.props.stateManager, inputBlock: inputBlock }, inputBlock.uniqueId) }));
            case ConnectionPointType.Color4:
                return (_jsx(_Fragment, { children: _jsx(Color4PropertyTabComponent, { stateManager: this.props.stateManager, inputBlock: inputBlock }, inputBlock.uniqueId) }));
            // case NodeMaterialBlockConnectionPointTypes.Vector3:
            //     return <Vector3PropertyTabComponent lockObject={globalState.lockObject} globalState={globalState} inputBlock={inputBlock} />;
            // case NodeMaterialBlockConnectionPointTypes.Vector4:
            //     return <Vector4PropertyTabComponent lockObject={globalState.lockObject} globalState={globalState} inputBlock={inputBlock} />;
            // case NodeMaterialBlockConnectionPointTypes.Matrix:
            //     return <MatrixPropertyTabComponent lockObject={globalState.lockObject} globalState={globalState} inputBlock={inputBlock} />;
            case ConnectionPointType.Vector2:
                return (_jsx(Vector2PropertyTabComponent, { inputBlock: inputBlock, lockObject: this.props.stateManager.lockObject, stateManager: this.props.stateManager }, inputBlock.uniqueId));
        }
        return _jsx(_Fragment, {});
    }
}
//# sourceMappingURL=inputNodePropertyComponent.js.map